<div class="wrapper">
  <div class="header">
    <div class="search">
      <div class="search-bar">
        <input style="border-radius: 5px; height: 45px; padding-left: 20px !important;"
          placeholder="Search by Employee ID / Name" aria-label="Number" class="form-control" matinput="" type="text"
          [(ngModel)]="searchText" (keyup)="applyFilter(searchText)">
        <button *ngIf="searchText" type="button" class="clear-button" (click)="clearSearch()">
          <span class="material-symbols-outlined">close</span>
        </button>
        <button type="submit" class="msicon append_button">
          <span class="material-symbols-outlined" onclick ="applyFilter(searchText)">search</span>
        </button>
      </div>
      <div class="toggle">
        <label class="user-label" [ngStyle]="{ 'font-weight': isExistingUser ? '400' : '700',
        'color': !isExistingUser ? '#3949AB' : 'inherit' }">
          New User
        </label>
        <mat-slide-toggle class="slide-toggle" color="primary" [(ngModel)]="isExistingUser" (change)="onToggleChange($event)">
          <label class="user-label" [ngStyle]="{ 'font-weight': isExistingUser ? '700' : '400',
          'color': isExistingUser ? '#3949AB' : 'inherit' }">
            Existing User
          </label>
        </mat-slide-toggle>
        </div>
      
      <div class="buttons-container">
        <button class="top-buttons" (click)="NoCompetencytoExcel()">
          <span class="material-symbols-outlined icon-style">download</span>
        </button>
        <button class="top-label-buttons" [disabled]="selection.selected.length<=0" (click)="decline()"> Decline
        </button>
        <button class="top-label-buttons" [disabled]="selection.selected.length<=0" (click)="approve()"> Approve
        </button>
      </div>
      <!-- <div>
        <button class="top-buttons" [disabled]="true" mat-flat-button color="primary" (click)="OpenCompDialog()"><i style="color:White" class="fas fa-plus"></i>Map Competency</button>
      </div>  -->
    </div>
  </div>

  <div class="data-grid">
    <mat-table [dataSource]="dataSource" matSort class="employees-table">
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                        [checked]="isAllSelected()"
                        [indeterminate]="isIndeterminate()"
                        [disabled]="!hasSelectableRows()">
          </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                        (change)="$event ? toggleSelection(row) : null"
                        [checked]="selection.isSelected(row)"
                        [disabled]="!isRowSelctable(row)">
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="employeeId">
        <mat-header-cell *matHeaderCellDef> Employee Id </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.employeeId}} </mat-cell>
      </ng-container>

      <!-- firstName Column -->
      <ng-container matColumnDef="employeeName">
        <mat-header-cell *matHeaderCellDef> Employee Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.firstName ?? "") + " " + (row.lastName ?? "")}}</mat-cell>
      </ng-container>

      <!-- LastName Column -->
      <!-- <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.lastName}} </mat-cell>
      </ng-container> -->

      <!-- Email Column -->
      <!-- <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span
            [ngStyle]="{'color': isInvalidEmail(row.emailAddress) ? 'red' : 'black'}"
            matTooltip="{{ row.emailAddress }}"
            matTooltipPosition="above"
          >
            {{ row.emailAddress }}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sourceSystemName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Source System Name </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.sourceSystemName ? row.sourceSystemName : 'Not Available'}} </mat-cell>
      </ng-container> -->

      <!-- Primary Skills Column -->
      <ng-container matColumnDef="primarySkills">
        <mat-header-cell *matHeaderCellDef> Primary Skills </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.primarySkillsUpdated ?? "Not Available")}}</mat-cell>
      </ng-container>

      <!-- Secondary Skills Column -->
      <ng-container matColumnDef="secondarySkills">
        <mat-header-cell *matHeaderCellDef> Secondary Skills </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.secondarySkillsUpdated ?? "Not Available")}}</mat-cell>
      </ng-container>

      <!-- Assigned Competency Column -->
      <ng-container matColumnDef="assignedComp">
        <mat-header-cell *matHeaderCellDef> Assigned Competency </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.assignedCompetencyName ?? "Not Assigned")}}</mat-cell>
      </ng-container>

      <!-- Assigned SubCompetency Column -->
      <ng-container matColumnDef="assignedSubComp">
        <mat-header-cell *matHeaderCellDef> Assigned SubCompetency </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.assignedSubCompetencyName ?? "Not Assigned")}}</mat-cell>
      </ng-container>

      <!-- Requested Competency Column -->
      <ng-container matColumnDef="requestedComp">
        <mat-header-cell *matHeaderCellDef> Requested Competency 
          <button class="filter-button" [matMenuTriggerFor]="competencyFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.requestedCompetencyName ?? "Not Requested")}}</mat-cell>
      </ng-container>

      <!-- Competency Filter Menu Below Header -->
      <mat-menu #competencyFilterMenu="matMenu">
        <div class="status-filter-checkboxes scrollable-checkbox-container">
          <mat-checkbox color="primary" *ngFor="let competency of competencyFilterOptions"
                        [(ngModel)]="competency.checked"
                        class="status-filter-checkbox"
                        (click)="$event.stopPropagation()">
              {{ competency.label }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions">
          <button mat-button (click)="resetFilters('competencyFilterOptions'); competencyFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyFilterByContext(); competencyFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
      </mat-menu>

      <!-- Requested SubCompetency Column -->
      <ng-container matColumnDef="requestedSubComp">
        <mat-header-cell *matHeaderCellDef> Requested SubCompetency 
          <button class="filter-button" [matMenuTriggerFor]="subCompetencyFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{(row.requestedSubCompetencyName ?? "Not Requested")}}</mat-cell>
      </ng-container>

      <!-- SubCompetency Filter Menu Below Header -->
      <mat-menu #subCompetencyFilterMenu="matMenu">
        <div class="status-filter-checkboxes scrollable-checkbox-container">
          <mat-checkbox color="primary" *ngFor="let subCompetency of subCompetencyFilterOptions"
                        [(ngModel)]="subCompetency.checked"
                        class="status-filter-checkbox"
                        (click)="$event.stopPropagation()">
              {{ subCompetency.subCompetencyName }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions">
          <button mat-button (click)="resetFilters('subCompetencyFilterOptions'); subCompetencyFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyFilterByContext(); subCompetencyFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
        </mat-menu>

      <!-- Sub COE Lead Column -->
      <ng-container matColumnDef="subCOELead">
        <mat-header-cell *matHeaderCellDef>Sub COE Lead 
          <button class="filter-button" [matMenuTriggerFor]="subCOEFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.subCOENames?.length ? row.subCOENames.join(", ") : "Not Available" }}</mat-cell>
      </ng-container>
      
      <!-- Sub COE Filter Menu Below Header -->
      <mat-menu #subCOEFilterMenu="matMenu">
        <div class="status-filter-checkboxes scrollable-checkbox-container">
          <mat-checkbox color="primary" *ngFor="let subCoe of subCOEFilterOptions" 
                        [(ngModel)]="subCoe.checked" 
                        class="status-filter-checkbox"
                        (click)="$event.stopPropagation()"
                        [hidden]="subCoe.hidden">
              {{ subCoe.label }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions">
          <button mat-button (click)="resetFilters('subCOEFilterOptions'); subCOEFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyFilterByContext(); subCOEFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
      </mat-menu>

      <!-- COE Lead Column -->
      <ng-container matColumnDef="coeLead">
        <mat-header-cell *matHeaderCellDef> COE Lead 
          <button class="filter-button" [matMenuTriggerFor]="coeFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row"> {{row.coeName ?? "Not Available"}}</mat-cell>
      </ng-container>
      
      <!-- COE Filter Menu Below Header -->
      <mat-menu #coeFilterMenu="matMenu">
        <div class="status-filter-checkboxes scrollable-checkbox-container">
          <mat-checkbox color="primary" *ngFor="let coe of coeFilterOptions" 
                        [(ngModel)]="coe.checked" 
                        class="status-filter-checkbox"
                        (click)="$event.stopPropagation()">
              {{ coe.label }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions">
          <button mat-button (click)="resetFilters('coeFilterOptions'); coeFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyFilterByContext(); coeFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
      </mat-menu>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status
          <!-- <i class="fa fa-filter filter-alt"></i>   -->
           <button class="filter-button" *ngIf="!isExistingUser" [matMenuTriggerFor]="statusFilterMenu">
            <span class="material-symbols-outlined filter-icon">filter_alt</span>
          </button>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span *ngIf="row.employeeCompetencyRequestedId; else defaultStatus" style="color: red; font-weight: bold;">
            Requested For Change
          </span>
          <ng-template #defaultStatus>
            <!-- {{ row.status }} -->
            <span Style="color:gray; font-weight: bold;">
              Unassigned
            </span>

          </ng-template>
        </mat-cell>
      </ng-container>

      <!-- Dropdown Filter Menu Below Header -->
      <mat-menu #statusFilterMenu="matMenu">
        <div class="status-filter-checkboxes">
          <mat-checkbox color="primary" *ngFor="let status of statusOptions" 
                        [(ngModel)]="status.checked" 
                        class="status-filter-checkbox"
                        (click)="$event.stopPropagation()">
            {{ status.label }}
          </mat-checkbox>
        </div>
        <div class="status-filter-actions">
          <button mat-button (click)="resetFilters('statusOptions'); statusFilterMenu?.closeMenu()"
            class="btn btn-outline btn-spacing"
            style="border: 2px solid #1976D2; color:#1976D2; font-weight:500;">Clear</button>
          <button mat-flat-button color="primary" (click)="applyStatusFilter(); statusFilterMenu?.closeMenu()"
            class="btn btn-primary" style="background: #1976D2; color: white;">Apply</button>
        </div>
      </mat-menu>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div class="action-buttons">
           <!-- View Button: Enabled only when toggle is ON and employeeCompetencyRequestedId is truthy -->
           <div class="action-buttons-view" [ngClass]="{ 'center-icon': isExistingUser }">
            <button mat-icon-button color="primary" (click)="view(row)"
                    [disabled]="!isExistingUser && !row.employeeCompetencyRequestedId"
                    matTooltip="View">
              <span class="material-symbols-outlined">visibility</span>
            </button>
          
            <button *ngIf="!isExistingUser" mat-icon-button (click)="edit(row)" matTooltip="Add" [disabled]="isEditDisabled(row)">
              <span class="material-symbols-outlined fs-14">edit</span>
            </button>
          </div>
          
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row [class.odd]="i % 2 == 1" [class.even]="i % 2 == 0"
        *matRowDef="let row; columns: displayedColumns; let i = index;">
      </mat-row>
    </mat-table>

    <!-- Show "No records found" message if no data -->
    <div *ngIf="dataSource?.data?.length === 0" class="no-records-container">
      <div class="no-records">
        <img src="../../../assets/images/no_data.png" height="120px"><br>
        <span class="mt-3 d-block">
          {{ isExistingUser ? 'No records found' : 'No records found for the search criteria' }}
        </span>
      </div>
    </div>

    <!-- Pagination -->
    <mat-paginator [length]="totalRecords" [pageSize]="10" [pageSizeOptions]="[10,20,40,50,60]" aria-label="Select page"
      (page)="getPaginatorData($event)"
      style=" height: 8vh;background: inherit; width: 98%; margin-left: 16px;"></mat-paginator>
  </div>
</div>